import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

export const oAuthConfig: AuthConfig = environment.oAuthConfig;
